import React, {Component} from "react";
import {withTranslate} from "react-redux-multilingual";
import {withRouter} from "react-router-dom";

class Auth extends Component {
    state = {
        image: null,
    };
    componentDidMount() {
        if(this.props.match.path !== "/activate"){
            localStorage.removeItem("access_token");
        }
    }
    render() {
        return (
            <div className="limiter">
                <div className="container-login100">
                    <div className="login100-more" style={{backgroundImage: 'url(images/registration.png)'}}></div>
                    {this.props.children}
                </div>
            </div>
        )
    }
}

export default withTranslate(withRouter(Auth))
